import React from "react";
import { getTimeBetweenInSec } from "utils/dateUtils";
import moment from "moment";
import { Icon, Label } from "semantic-ui-react";

const styles = {
	info: { width: "100%", textAlign: "center", color: "darkcyan", fontSize: "0.9em" },
};

const TubeWithTimerInfo = ({ tubes, t }) => {
	if (tubes) {
		var sampled = tubes.filter((t) => !!t.sampling_time).sort((t) => t.sampling_time);
		var nextToSampleWithTimer = tubes
			.filter((t) => t.status === "NEW" && t.properties && t.properties.timer > 0)
			.sort((t1, t2) => t1.properties.timer - t2.properties.timer);
		if (nextToSampleWithTimer && nextToSampleWithTimer.length > 0) {
			if (sampled && sampled[0] && sampled[0].sampling_time) {
				const waitingTime = getTimeBetweenInSec(moment(sampled[0].sampling_time).add(nextToSampleWithTimer[0].properties.timer, "m")) / 60;
				if (Math.floor(waitingTime) <= 0)
					return (
						<Label style={styles.info} color="green" basic>
							<Icon name="hourglass end" />
							<span>{t("foldersOverview.sampleTube")}</span>
						</Label>
					);
				return (
					<Label style={styles.info} color="grey" basic>
						<Icon name="hourglass half" />
						<span>{t("foldersOverview.nextSampleTube", { min: Math.floor(Math.abs(waitingTime)) })}</span>
					</Label>
				);
			} else
				return (
					<Label style={styles.info} basic>
						<Icon name="hourglass start" />
						<span>{t("foldersOverview.firstSampleTube")}</span>
					</Label>
				);
		}
	}

	return null;
};

export default TubeWithTimerInfo;
